import Permissions from '@app/src/auth/permissions'
import navigationLinks from '@app/src/wf-constants/navigationLinks'
import paths from '@app/src/wf-constants/paths'
import React from 'react'
import { useIntl } from 'react-intl'
import type { MenuLinkWrapperProps } from './LegacyMenuWrapper'
import { MenuLinkWrapper } from './LegacyMenuWrapper'
import type { NavbarItemProps } from './LegacyNavbarItems'

const dashboardActivePaths = [
  paths.dashboard,
  paths.sourcingDashboard,
  paths.investmentDashboard,
  paths.financeDashboard,
  paths.transparencyDashboard,
]

const DashboardLink: React.FC<NavbarItemProps> = ({ closeMenuDrawer }) => {
  const { formatMessage } = useIntl()

  const menuItems: MenuLinkWrapperProps['menuItems'] = {
    link: navigationLinks.dashboard,
    permission: [
      Permissions.TRANSPARENCY_USER,
      Permissions.SOURCING_USER,
      Permissions.FINANCE_USER,
      Permissions.INVESTMENT_USER,
    ],
  }

  return (
    <MenuLinkWrapper
      closeMenuDrawer={closeMenuDrawer}
      menuItems={menuItems}
      activePaths={dashboardActivePaths}
      title={formatMessage({ id: 'general.home' })}
    />
  )
}

export default DashboardLink
